module.exports = __webpack_public_path__ + "img/explain-in-detail.bc1ec654.png";